<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <places-form :place="place" :loader="loader" @click="storePlace(place)" :showLabels="false"></places-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import placesApi from '../../api/places'
  import placesForm from './Form.vue'
  import Place from '../../models/place'

  export default {

    components: {
      placesForm
    },
    data () {
      return {
        place: new Place(),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuovo luogo',
        createButton: {display: false}
      })
    },

    methods: {
      storePlace (place) {
        this.loader = true
        place.archive_id = this.$store.state.profile.profile.archive.data.id
        placesApi.store(place)
          .then((response) => {
            toastr.success('Il luogo è stato inserito correttamente')
            this.$router.push('/places')
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/places/Create.vue